import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, Outlet } from 'react-router-dom'
import { Nav, Navbar, NavItem } from 'reactstrap'
import classnames from 'classnames'

import PageHeader from '../common/PageHeader/PageHeader'
import Loader from '../common/loader/legacy-loaders/Op36Loader-web'

import classes from './CommunitySettingsPage.module.scss'
import { setCurrentTab, showNavBar, showSideBar } from '../../actions/commonActions'

const tabsData = [
  {
    name: 'Pricing & Packages',
    path: 'pricing',
  },
  {
    name: 'Landing Page',
    path: 'landing',
  },
  {
    name: 'Registration Access Code',
    path: 'access-code',
  },
  {
    name: 'Op 36 Clubs',
    path: 'clubs',
  },
]

const CommunitySettingsPage = () => {
  const dispatch = useDispatch()

  const isLoadingUserRefresh = useSelector(state => state.loading.isLoading)

  useEffect(() => {
    dispatch(setCurrentTab('Community-Settings'))
    dispatch(showSideBar(true))
    dispatch(showNavBar(true))
  }, [dispatch])

  if (isLoadingUserRefresh === false) {
    return (
      <div className={classnames('d-flex flex-column', classes['community-settings-page'])}>
        <PageHeader title='Community Settings' />
        <Navbar className={classes.navbar}>
          <Nav className={classes.nav} tabs>
            {tabsData.map((tabData, index) => (
              <NavItem key={index} className={classes.navItem}>
                <NavLink
                  to={tabData.path}
                  className={({ isActive }) => classnames(classes.navLink, { [classes.active]: isActive })}
                >
                  {tabData.name}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Navbar>
        <main className={classes.main}>
          <Outlet />
        </main>
      </div>
    )
  }

  return <Loader message='Loading Community Settings...' />
}

export default CommunitySettingsPage
